import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardPage from './pages/dashboard';
import SellerPage from './pages/sellers';
import OrdarsPage from './pages/OrdarsPages';
import DeliveryPage from './pages/DeliveryPages';

// saller
import SellerInfo from './pages/sellerInfo/SellerInfo';
import UserOrders from './pages/user/UserOrders';
import UserDetails from './pages/user/UserDetails';
// delivery
import DeliveryOrders from './pages/delivery/DeliveryOrders';
import DeliveryInfo from './pages/delivery/DeliveryInfo';
// Orders
import OrdersDetails from './pages/orders/OrdersDetails';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'seller', element: <SellerPage /> },
        { path: 'ordar', element: <OrdarsPage /> },
        { path: 'deliver', element: <DeliveryPage /> },
        { path: 'blog', element: <BlogPage /> },


      ],
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/delete-account',
      element: <DeleteAccountPage />,
    },    
    {
      path: 'seller-info/:id',
      element: <SellerInfo />,
    },
    {
      path: 'user-orders/:id',
      element: <UserOrders />,
    },
    {
      path: 'user-info/:id',
      element: <UserDetails />,
    },
    {
      path: 'delivery-orders/:id',
      element: <DeliveryOrders />,
    },
    {
      path: 'delivery-info/:id',
      element: <DeliveryInfo />,
    },
    {
      path: 'order-info/:id',
      element: <OrdersDetails />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
